function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnMenuAdd = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 186",
  style: {
    fill: "none"
  },
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8 6.3V.414a6.279 6.279 0 0 1 2.219 1.431l3.136 3.137A6.259 6.259 0 0 1 19.586 7.2H13.7a.9.9 0 0 1-.9-.9zM20 9.436V17.1a4.505 4.505 0 0 1-4.5 4.5h-9A4.505 4.505 0 0 1 2 17.1V4.5A4.505 4.505 0 0 1 6.5 0h4.063c.147 0 .292.012.436.022V6.3A2.7 2.7 0 0 0 13.7 9h6.278c.01.145.022.29.022.436zM14.6 15.3a.9.9 0 0 0-.9-.9h-1.8v-1.8a.9.9 0 1 0-1.8 0v1.8H8.3a.9.9 0 1 0 0 1.8h1.8V18a.9.9 0 1 0 1.8 0v-1.8h1.8a.9.9 0 0 0 .9-.9z",
  transform: "translate(3 3)",
  style: {
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnMenuAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fe8b182c006100c3346a792c29bea031.svg";